import React from 'react';
import { motion } from 'framer-motion';
import Logo from '../Logo';
import SearchBar from './SearchBar';
// import NotificationButton from './NotificationButton';
import ProfileDropdown from './ProfileDropdown';

const Header: React.FC = () => {
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="sticky top-0 z-30 h-16 bg-white/90 backdrop-blur-xl shadow-lg shadow-gray-300 flex items-center px-4 lg:px-6 gap-4 container mx-auto rounded-lg mt-2"
    >
      <div className="lg:hidden">
        <Logo />
      </div>
      <SearchBar />
      <div className="flex-1 lg:hidden" />
      <div className="flex items-center gap-3 ml-auto">
        {/* <NotificationButton /> */}
        <ProfileDropdown />
      </div>
    </motion.header>
  );
};

export default Header;